import { cn } from "@/lib/cn";

export function ExpiryMeter({
  daysRemaining,
  validityDays = 365,
  size = 72,
  strokeWidth = 7,
}: {
  daysRemaining: number;
  validityDays?: number;
  size?: number;
  strokeWidth?: number;
}) {
  const r = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(daysRemaining, validityDays));
  const progress = clamped / validityDays;
  const dash = circumference * progress;

  const tone =
    daysRemaining <= 0
      ? { stroke: "#ef4444", text: "text-red-700" }
      : daysRemaining < 30
      ? { stroke: "#f59e0b", text: "text-amber-700" }
      : daysRemaining < 90
      ? { stroke: "#2563eb", text: "text-brand-700" }
      : { stroke: "#10b981", text: "text-emerald-700" };

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="rgb(226 232 240)"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={tone.stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={`${dash} ${circumference}`}
        />
      </svg>
      <div className={cn("absolute inset-0 flex flex-col items-center justify-center leading-none", tone.text)}>
        <span className="text-lg font-semibold">{Math.max(daysRemaining, 0)}</span>
        <span className="mt-0.5 text-[9px] font-medium uppercase tracking-wider opacity-80">días</span>
      </div>
    </div>
  );
}
